import React, { useState, useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import httpService from 'services/httpService';
import fileDownload from 'js-file-download';
import { Spinner } from 'react-bootstrap';
import * as constants from 'Constants';
import { RiArrowDropDownLine, RiArrowDropRightLine } from 'react-icons/ri';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';

const BulkSubmissionModal = ({
    program_id,
    setBulkSubmissionStatus,
    showPopupBulkSubmission,
    setShowPopupBulkSubmission,
}) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileSize, setFileSize] = useState(true); // states to handle file issues
    const [fileUploadProgress, setFileUploadProgress] = useState(false);
    const [fileUploadResponse, setFileUploadResponse] = useState(null);
    const fileInputRef = useRef(null);
    const [copied, setCopied] = useState(false);
    const [isFailedSubAccordionOpen, setIsFailedSubAccordionOpen] =
        useState(false);
    const [isErrorAccordionOpen, setIsErrorAccordionOpen] = useState(false);
    const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);

    const handleButtonClick = (event) => {
        event.preventDefault();
        fileInputRef.current.click();
    };

    // Function to handle file selection
    const handleFileSelect = (event) => {
        event.preventDefault();
        setSelectedFile(event.target.files[0]);
    };

    // Function to handle file drop
    const handleFileDrop = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const file = event.dataTransfer.files[0];
        setSelectedFile(file);
    };

    // Function to prevent default behavior of file drop
    const preventDefaultBehavior = (event) => {
        event.preventDefault();
        // event.stopPropagation();
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(
            JSON.stringify(fileUploadResponse, null, 2)
        );
        setCopied(true);
        setTimeout(() => {
            setCopied(false);
        }, 2000);
    };

    const bulkInstructionsDownload = () => {
        var url = constants.base_url + '/evalpro/bulk_submission_instructions';
        httpService.instance({
            url,
            method: 'GET',
            responseType: 'blob', // Important
        }).then((response) => {
            fileDownload(response.data, 'BulkUploadInstructions.pdf');
        });
    };

    const onFileUpload = (e) => {
        e.preventDefault();
        if (!selectedFile) {
            setFileSize(false);
            return;
        }

        setFileUploadProgress(true);
        const form_data = new FormData();
        form_data.append('file', selectedFile);
        const getresponse = async () => {
            const url =
                constants.base_url + '/evalpro/upload/bulk/' + program_id;
            try {
                const response = await httpService.post(url, form_data, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                setFileUploadResponse(response.data['bulk_submission_status']);
            } catch (error) {
                setFileUploadResponse(error.response.data);
            } finally {
                setFileUploadProgress(false);
                setSelectedFile(null);
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
            }
        };
        getresponse();
    };

    const WarningModal = () => {
        // ask a question to check if he really wants to close the modal

        return (
            <Modal
                show={isWarningModalOpen}
                onHide={() => {
                    setIsWarningModalOpen(false);
                }}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Warning</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to close the modal?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => {
                            setIsWarningModalOpen(false);
                        }}
                    >
                        No
                    </Button>
                    <Button
                        variant="primary"
                        onClick={() => {
                            setFileUploadProgress(false);
                            setIsWarningModalOpen(false);
                            setShowPopupBulkSubmission(false);
                            setBulkSubmissionStatus((state) => !state);
                        }}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

    return (
        <Modal
            show={showPopupBulkSubmission}
            dialogClassName="modal-90w"
            onHide={() => {
                if (fileUploadResponse != null) {
                    setBulkSubmissionStatus((state) => !state);
                }
                setSelectedFile(null);
                setFileUploadResponse(null);
                fileUploadProgress
                    ? setIsWarningModalOpen(true)
                    : setShowPopupBulkSubmission(false);
            }}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title>Bulk Upload</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <WarningModal />
                <div className="file-upload-container">
                    <div
                        className="file-upload"
                        onDrop={handleFileDrop}
                        onDragOver={preventDefaultBehavior}
                        style={{
                            position: 'relative',
                        }}
                    >
                        <Button variant="secondary" onClick={handleButtonClick}>
                            Choose File
                        </Button>
                        <input
                            type="file"
                            onChange={handleFileSelect}
                            id={'files'}
                            ref={fileInputRef}
                            style={{
                                display: 'none',
                            }}
                        />

                        {fileUploadProgress ? (
                            <Button
                                variant="primary"
                                id={1}
                                style={{
                                    position: 'absolute',
                                    right: '10px',
                                }}
                            >
                                Uploading...
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            </Button>
                        ) : (
                            <Button
                                variant="primary"
                                onClick={onFileUpload}
                                id={1}
                                style={{
                                    position: 'absolute',
                                    right: '10px',
                                }}
                            >
                                Upload
                            </Button>
                        )}
                    </div>
                    {selectedFile && (
                        <div
                            className="file-details"
                            key={'filename'}
                            style={{
                                marginBottom: '4px',
                                marginTop: '10px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '5px',
                                background: '#edf0f2',
                                borderRadius: '4px',
                                width: 'fit-content',
                            }}
                        >
                            <span>{selectedFile?.name}</span>{' '}
                        </div>
                    )}

                    <p
                        style={{
                            marginTop: '10px',
                            border: '1px solid #d6d6d6',
                            padding: '10px',
                            borderRadius: '5px',
                            position: 'relative',
                        }}
                    >
                        <b>Upload Instructions</b> : <br />
                        You need to upload with following{' '}
                        <b>Directory Structure</b> : <br />
                        Bulk.zip <br />
                        | Bulk <br />
                        |__student1@example.com <br />
                        <span style={{ wordSpacing: '1em' }}>
                            {' '}
                            |{' '}
                        </span> |__file1 <br />
                        <span style={{ wordSpacing: '1em' }}>
                            {' '}
                            |{' '}
                        </span> |__file2 <br />
                        <span style={{ wordSpacing: '1em' }}> | </span> . <br />
                        <span style={{ wordSpacing: '1em' }}> | </span> . <br />
                        |__student2@example.com <br />
                        <span style={{ wordSpacing: '1em' }}>
                            {' '}
                            |{' '}
                        </span> |__file1 <br />
                        <span style={{ wordSpacing: '1em' }}>
                            {' '}
                            |{' '}
                        </span> |__file2 <br />
                        <span style={{ wordSpacing: '1em' }}> | </span> . <br />
                        <span style={{ wordSpacing: '1em' }}> | </span> . <br />
                        . <br />
                        . <br />
                        <b>NOTE :</b>
                        <ul>
                            <li>
                                Zip the Directory with name= 'Bulk' and upload
                                it. It can be anything.
                            </li>
                            <li>
                                Folder names should be student email id. 
                                File1, File2 should be the name of the files to
                                be submitted.
                            </li>
                        </ul>
                        {/* <Button variant="secondary" onClick={bulkInstructionsDownload} style={{ position: "absolute", right: "10px", bottom: "10px" }}>
              Download Instructions
            </Button> */}
                    </p>

                    {!fileUploadProgress && fileUploadResponse && (
                        <Alert
                            show={true}
                            variant={
                                fileUploadResponse['failed_submissions'] === 0
                                    ? 'success'
                                    : 'danger'
                            }
                            style={{
                                marginBottom: '10px',
                                width: 'fit-content',
                            }}
                        >
                            {fileUploadResponse['failed_submissions'] === 0
                                ? 'Upload Successful'
                                : 'Upload Failed'}
                        </Alert>
                    )}

                    {!fileUploadProgress &&
                        fileUploadResponse &&
                        fileUploadResponse['failed_submissions'] !== 0 && (
                            <div
                                style={{
                                    position: 'relative',
                                }}
                            >
                                <button
                                    onClick={handleCopy}
                                    id={1}
                                    style={{
                                        position: 'absolute',
                                        right: '10px',
                                        top: '5px',
                                        fontSize: '15px',
                                        backgroundColor: 'transparent',
                                        color: '#cccccc',
                                        padding: '1px',
                                        border: 'none',
                                    }}
                                >
                                    {' '}
                                    {copied ? 'copied!' : 'copy'}{' '}
                                </button>
                                {/* <pre style={{
                backgroundColor: "#121212",
                color: "#f8f8f8",
                padding: "10px",
                maxHeight: "200px",
              }}> {JSON.stringify(fileUploadResponse, null, 2)} </pre> */}
                            </div>
                        )}

                    <div className="Acc">
                        <Accordion>
                            {fileUploadResponse &&
                                'total_submissions' in fileUploadResponse && (
                                    <Card>
                                        <Card.Header>
                                            <Accordion.Toggle
                                                as="Text"
                                                eventKey="0"
                                            >
                                                Total Submissions :{' '}
                                                {
                                                    fileUploadResponse[
                                                        'total_submissions'
                                                    ]
                                                }
                                            </Accordion.Toggle>
                                        </Card.Header>
                                    </Card>
                                )}
                            {fileUploadResponse &&
                                'total_submissions' in fileUploadResponse && (
                                    <Card>
                                        <Card.Header>
                                            <Accordion.Toggle
                                                as="Text"
                                                eventKey="0"
                                            >
                                                Accepted Submissions :{' '}
                                                {fileUploadResponse[
                                                    'total_submissions'
                                                ] -
                                                    fileUploadResponse[
                                                        'failed_submissions'
                                                    ]}
                                            </Accordion.Toggle>
                                        </Card.Header>
                                    </Card>
                                )}
                            {fileUploadResponse &&
                                'failed_submissions' in fileUploadResponse &&
                                fileUploadResponse['failed_submissions'] !==
                                    0 && (
                                    <Card>
                                        <Accordion.Toggle
                                            as={Card.Header}
                                            eventKey="0"
                                            onClick={() =>
                                                setIsFailedSubAccordionOpen(
                                                    !isFailedSubAccordionOpen
                                                )
                                            }
                                        >
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent:
                                                        'space-between',
                                                }}
                                            >
                                                <div>
                                                    {' '}
                                                    Failed Submissions :{' '}
                                                    {
                                                        fileUploadResponse[
                                                            'failed_submissions'
                                                        ]
                                                    }{' '}
                                                </div>
                                                <div>
                                                    {isFailedSubAccordionOpen ? (
                                                        <RiArrowDropRightLine
                                                            size={35}
                                                            color="grey"
                                                            style={{
                                                                margin: '-10 0 -10 10',
                                                            }}
                                                        />
                                                    ) : (
                                                        <RiArrowDropDownLine
                                                            size={35}
                                                            color="grey"
                                                            style={{
                                                                margin: '-10 0 -10 10',
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </Accordion.Toggle>

                                        <Accordion.Collapse
                                            in={!isFailedSubAccordionOpen}
                                            eventKey="0"
                                        >
                                            <Card.Body>
                                                <pre
                                                    style={{
                                                        backgroundColor:
                                                            '#121212',
                                                        color: '#f8f8f8',
                                                        padding: '10px',
                                                        maxHeight: '200px',
                                                    }}
                                                >
                                                    {' '}
                                                    {JSON.stringify(
                                                        fileUploadResponse[
                                                            'details'
                                                        ],
                                                        null,
                                                        2
                                                    )}{' '}
                                                </pre>
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                )}

                            {fileUploadResponse &&
                                'error' in fileUploadResponse && (
                                    <Card>
                                        <Accordion.Toggle
                                            as={Card.Header}
                                            eventKey="0"
                                            onClick={() =>
                                                setIsErrorAccordionOpen(
                                                    !isErrorAccordionOpen
                                                )
                                            }
                                        >
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent:
                                                        'space-between',
                                                }}
                                            >
                                                <div>Error</div>
                                                <div>
                                                    {isErrorAccordionOpen ? (
                                                        <RiArrowDropRightLine
                                                            size={35}
                                                            color="grey"
                                                            style={{
                                                                margin: '-10 0 -10 10',
                                                            }}
                                                        />
                                                    ) : (
                                                        <RiArrowDropDownLine
                                                            size={35}
                                                            color="grey"
                                                            style={{
                                                                margin: '-10 0 -10 10',
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </Accordion.Toggle>

                                        <Accordion.Collapse
                                            in={!isErrorAccordionOpen}
                                            eventKey="0"
                                        >
                                            <Card.Body>
                                                <pre
                                                    style={{
                                                        backgroundColor:
                                                            '#121212',
                                                        color: '#f8f8f8',
                                                        padding: '10px',
                                                        maxHeight: '200px',
                                                    }}
                                                >
                                                    {' '}
                                                    {JSON.stringify(
                                                        fileUploadResponse[
                                                            'error'
                                                        ],
                                                        null,
                                                        2
                                                    )}{' '}
                                                </pre>
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                )}
                        </Accordion>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default BulkSubmissionModal;
